import { Badge } from 'element-ui'

const YBadge = Badge
YBadge.$depends = [Badge]
YBadge.$name = 'y-badge'
YBadge._name = 'Badge 标记'

export default YBadge
